import fallbacks from './fallbackValues';

type Status = {
	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
};

export const getImageByStatus = (
	imgSrc: string | undefined,
	idx: number | string,
	status: Status,
) => {
	const { isError, lackOfPermission } = status;
	if (isError || !imgSrc) return fallbacks.imgSrc.error;
	if (lackOfPermission) return fallbacks.imgSrc.example(idx);
	return imgSrc;
};

export const getTitleByStatus = (title: string | undefined, status: Status) => {
	const { isLoading, isError, lackOfPermission } = status;
	if (isLoading) return fallbacks.title.loading;
	if (isError || !title) return fallbacks.title.empty;
	if (lackOfPermission) return fallbacks.title.example;
	return title;
};

export const getHashtagsArrayByStatus = (
	hashtags: string[] | undefined,
	status: Status,
) => {
	const { isLoading, isError, lackOfPermission } = status;
	if (isLoading || isError) return fallbacks.hashtags.empty;
	if (lackOfPermission) return fallbacks.hashtags.example;
	return hashtags;
};

export const getHashtagsString = (hashtags?: string[]) => {
	if (!hashtags || hashtags.length === 0) return '';
	return hashtags.map((item) => `#${item}`).join(' ');
};
